$ = require 'jquery'
Backbone = require 'backbone'
Storage = require 'lib/storage'
_ = require 'underscore'

module.exports = new class
  _.extend @prototype, Backbone.Events

  cancelEdit: ($el) ->
    $el.find('.edit-controls:not(.keep)').remove()
    $el.removeClass('editing is-editing is-focused focus')
    $el.blur()

  cancelEdits: (elExclude) ->
    $('.edit-controls:not(.keep)').remove()
    $('.is-editing').removeClass('is-editing')
    $('.is-focused').removeClass('is-focused')
    $('.checklist-new-item').removeClass('focus')
    $('input').not(elExclude || "none").blur()
    $('textarea').not(elExclude || "none").blur()

    @trigger 'cancelEdits'

    editableFields = $('.editable')
    if editableFields.length > 0
      editableFields.each (i) =>
        editableField = $('.editable')[i]
        isEditing = $(editableField).hasClass('editing')
        warning = $(editableField).find('.edits-warning:first')
        current = $(editableField).find('.current:first')
        field = $(editableField).find('.field:first')
        draftKey = field.data('draftKey')

        saveDraft =
          if (unmarkeddown = current.data("unmarkeddown"))?
            unmarkeddown != field.val()
          else
            field.val() != current.text()

        if saveDraft && draftKey? && isEditing
          if field.hasClass('field-autosave')
            @trigger 'autosaveEdits', $(editableField)
          # Dont save the draft unless they made edits that are not empty
          else if field.val() != ''
            Storage.set(draftKey, field.val())
            warning.show()

    $('.editing').removeClass('editing')


  isEditing: ->
    return (($('.editing').length + $('.checklist-new-item.focus').length + $('.is-focused').length) > 0)



// WEBPACK FOOTER //
// ./app/scripts/views/lib/layout.coffee